import { FC } from 'react';

import { useTitleHook } from '../../../bugo/hooks/useTitleHook';
import { CouponHistorySection } from '../../components/giftSettlement/CouponHistorySection';
import { CouponPendingSection } from '../../components/giftSettlement/CouponPendingSection';
import { ROLE } from '../../utils/coupon-settlement.utils';

/**
 * 상조관리자(BugoAgencyAdmin) 쿠폰형 정산 — admin 페이지(GiftSettlementAgencyCouponPage)와
 * **완전 동일한 view**를 같은 섹션 컴포넌트로 그린다 (2026-07-02 사용자 결정).
 * - 미정산: 통계 테이블 → 상세보기 모달 (검색·엑셀·초과 배너·재발행 뱃지 포함,
 *   체크박스·집행만 없음 — CouponPendingSection readOnly)
 * - 완료 내역: 상태 필터 목록 → 상세 모달 (초과 제외 섹션·엑셀 동일, 쓰기 UI 없음)
 * 기존 고유 요소(Draft 요약 카드·연간 캘린더·발송/환불 분리 테이블)는 제거 —
 * Draft는 목록의 '정산집계' 상태 행으로 확인한다. 스코프는 서버 owningFilter가 강제
 * (본인 상조만 — 미정산 통계 테이블엔 자기 상조 1행만 온다).
 */
export const AgencyGiftCouponSettlementContainer: FC = () => {
  useTitleHook('쿠폰형 정산');

  return (
    <div>
      <h1 className="mb-6 text-2xl font-bold text-gray-900">쿠폰형 정산</h1>

      {/* 미정산 내역 (상단) — view 전용 */}
      <section className="mb-10">
        <h2 className="mb-4 text-lg font-bold text-gray-800">미정산 내역</h2>
        <CouponPendingSection readOnly role={ROLE} />
      </section>

      {/* 정산 완료 내역 (하단) — 읽기 전용 목록 + 상세 모달 */}
      <section>
        <h2 className="mb-4 text-lg font-bold text-gray-800">정산 완료 내역</h2>
        <CouponHistorySection
          isAdmin={false}
          refreshTrigger={0}
          role={ROLE}
          hideBrandColumn
        />
      </section>
    </div>
  );
};
